"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const common_1 = require("../../../common");
const OcmOpenShiftVersion = ({ openshiftVersion, clusterCpuArchitecture, versions, withPreviewText, withMultiText, }) => {
    return (react_1.default.createElement(common_1.StaticTextField, { name: "openshiftVersion", label: "OpenShift version", isRequired: true },
        "OpenShift",
        ' ',
        (0, common_1.getOpenshiftVersionText)({
            openshiftVersion,
            cpuArchitecture: clusterCpuArchitecture,
            versions,
            withPreviewText,
            withMultiText,
        })));
};
exports.default = OcmOpenShiftVersion;
//# sourceMappingURL=OcmOpenShiftVersion.js.map